module.exports = __webpack_public_path__ + "img/9.9d1be4d1.png";